module.exports = __webpack_public_path__ + "static/media/popup_audio_mixer.687a9791.svg";